import { useCallback } from "react";

const useCheckParentKeyExist = (expandedKeys, combinedResponse) => {
    const checkParentKeyExist = useCallback(
        (nodeData) => {
            let expandedKeyss = [...expandedKeys, nodeData.key];

            const traverse = (resp, parentId) => {
                for (const node of resp) {
                    if (node.id === parentId) {
                        if (!expandedKeyss.includes(node.id)) {
                            expandedKeyss.push(node.id);
                        }
                        traverse(combinedResponse, node.parent_id);
                        break;
                    }
                }
            };

            traverse(combinedResponse, nodeData?.parent_id);
            return expandedKeyss;
        },
        [expandedKeys, combinedResponse]
    );

    return { checkParentKeyExist };
};

export default useCheckParentKeyExist;
